import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import DocumentTitle from 'react-document-title'
import SimulationsList from './SimulationsList'

const simulationsBreadcrumbs: Array<PageLink> = [
  {
    title: 'Simulations',
    path: '/simulations/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const SimulationsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='list'
          element={
            <>
              <DocumentTitle title={process.env.REACT_APP_NAME + ' | Simulations'}></DocumentTitle>
              <PageTitle breadcrumbs={simulationsBreadcrumbs}>Simulations</PageTitle>
              <SimulationsList />
            </>
          }
        />
        <Route index element={<Navigate to='/simulations/list' />} />
      </Route>
    </Routes>
  )
}

export default SimulationsPage
